import BaseMixin from './base.mixin'
import LocalStorageMixin from '@/shared/mixins/local-storage.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'

const mixin = {
  mixins: [BaseMixin, LocalStorageMixin, AuthMixin],
  methods: {
    async getRadioExamsList() {
      try {
        const response = await this.requestGet(`/core/FastReport`)
        if (response && response.data) {
          return response.data
        } else {
          throw new Error('Resposta da API inválida')
        }
      } catch (error) {
        throw new Error('Erro ao buscar lista de exames: ' + error.message)
      }
    },
    async getDetails(examId) {
      try {
        const response = await this.requestGet(`/core/Exams/${examId}`)
        if (response && response.data) {
          return response.data
        } else {
          throw new Error('Resposta da API inválida')
        }
      } catch (error) {
        console.error('Erro ao buscar detalhes do exame:', error)
        return ''
      }
    },
    async examRepeatRadio(examId, reason) {
      try {
        const response = await this.requestPost(`/core/FastReport/${examId}/Repeat`, {
          reason
        })

        if (response && response.data) {
          return response.data
        } else {
          throw new Error('Resposta da API inválida')
        }
      } catch (error) {
        throw new Error('Erro ao repetir o exame: ' + error.message)
      }
    },

    async getExamNotes(examId) {
      try {
        const response = await this.requestGet(`/core/FastReport/${examId}/Notes`)
        if (response && response.data) {
          return response.data.notes
        } else {
          throw new Error('Resposta da API inválida')
        }
      } catch (error) {
        throw new Error('Erro ao buscar relatório do exame: ' + error.message)
      }
    },

    async getMaskOptions(specialty) {
      try {
        const response = await this.requestGet(`/core/Physician/Mask/${specialty}`)
        if (!response || !response.data) {
          console.warn('No data in mask response')
          return { data: [] }
        }

        return response
      } catch (error) {
        console.error('Error in getMaskOptions:', error)
        if (error.response) {
          console.error('Error response:', error.response)
        }
        return { data: [] }
      }
    },

    async sendReportRadio(examId, payload) {
      try {
        const response = await this.requestPost(`/core/FastReport/${examId}/Report`, payload, {
          headers: { 'Content-Type': 'application/json' }
        })
        return response
      } catch (error) {
        throw new Error(
          'Erro ao enviar o relatório: ' + (error.response?.data?.errors[0]?.message || 'Erro desconhecido')
        )
      }
    },

    async duplicateExam(payload) {
      try {
        const response = await this.requestPost('/core/Exam/Clone', payload)
        if (response && response.data) {
          return response.data.data
        }
      } catch (error) {
        throw new Error('Erro ao duplicar exame: ' + error.message)
      }
    },

    async getPreviousExamsByExamId (examId) {
      try {
        const response = await this.requestGet(`/core/Physician/Exams/${examId}/Previous`)
        if (response && response.data) {
          return response.data
        } else {
          throw new Error('Resposta da API inválida');
        }
      } catch (error) {
        console.error('Erro ao buscar exames anteriores:', error)
        return []
      }
    },

    async getFreeFilteredExams (filters, examId) {
      try {
        if (!examId) {
          return []
        }
        const query = new URLSearchParams()
        if (examId) query.append('ExamId', examId)
        if (filters.name) query.append('Name', filters.name)
        // Adapta a data de nascimento pro formato americano
        if (filters.dateOfBirth) {
          const [year, month, day] = filters.dateOfBirth.split('-');
          const usDate = `${month}-${day}-${year}`;
          query.append('DateOfBirth', usDate);
        }
        if (filters.document) query.append('Document', filters.document)
        if (filters.gender) query.append('Gender', filters.gender)

        const finalUrl = `/core/Exams?${query.toString()}`
        const response = await this.requestGet(finalUrl)
        return response?.data || []
      } catch (error) {
        console.error('Erro ao buscar exames com filtro livre:', error)
        return []
      }
    },

    async getListSpecialties(specialityId, sourceId) {
      try {
        const response = await this.requestGet(`/core/ExamSource/Speciality/GetExternal?specialityId=${specialityId}&sourceId=${sourceId}`)
        if (response && response.data) {
          return response.data
        }
      } catch (error) {
        throw new Error('Erro ao duplicar exame: ' + error.message)
      }
    },
    async getAttachmentTypes () {
      try {
        const response = await this.requestGet('/core/File/AttachmentType/GetAll')
        if (response && response.data) {
          return response.data
        }
        throw new Error('Resposta da API inválida')
      } catch (error) {
        throw new Error('Erro ao buscar tipos de anexos: ' + error.message)
      }
    },
    getBaseItemForFastReport () {
      const url = '/core/Physician/Exams/GetBaseItem'
      const params = { forFastReport: true }
      return this.getClient().get(url, { params }, true)
    }
  }
}

export default mixin
